import styled, { css } from 'styled-components';

const action = {
  url: '/static/education/shapes/action.svg'
};

const method = {
  url: '/static/education/shapes/method.svg'
};

const workshop = {
  url: '/static/education/shapes/workshop.svg'
};

const presentation = {
  url: '/static/education/shapes/presentation.svg'
};

const training = {
  url: '/static/education/shapes/training.svg'
};

const collection = {
  url: '/static/education/shapes/collection.svg',
  position: 'center',
  size: 'auto 150%'
};

const tutorial = {
  url: '/static/education/shapes/tutorial.svg'
};

const maskOptions = {
  method,
  action,
  workshop,
  presentation,
  training,
  collection,
  tutorial
};

const backgroundColors = {
  ressources: {
    default: '#9770C8',
    dark: '#64389A'
  },
  agriculture: {
    default: '#A6DD89',
    dark: '#6AA349'
  },
  work: {
    default: '#E26372',
    dark: '#B04B57'
  },
  energy: {
    default: '#AD7496',
    dark: '#92577A'
  },
  nutrition: {
    default: '#45A88F',
    dark: '#308D76'
  },
  health: {
    default: '#EE9E77',
    dark: '#EA7137'
  },
  mobility: {
    default: '#F3C85E',
    dark: '#D39908'
  },
  city: {
    default: '#117D94',
    dark: '#0D6477'
  },
  democracy: {
    default: '#D1578D',
    dark: '#8E3B60'
  }
};

const StyledEducationShape = styled.div`
  ${({ category }) =>
    category &&
    css`
      background-color: ${backgroundColors[category]?.default || 'inherit'};
    `};

  ${props =>
    props.multipleTopics &&
    css`
      background: linear-gradient(180deg, #fa2ec2 0%, #008aff 100%);
    `}

  .clipped {
    ${({ contentType }) =>
      contentType &&
      css`
        mask-image: url(${maskOptions[contentType]?.url});
        mask-repeat: no-repeat;
        mask-position: ${maskOptions[contentType]?.position || 'center'};
        mask-size: ${maskOptions[contentType]?.size || 'auto 100%'};
      `};

    ${props =>
      props.multipleTopics &&
      css`
        background: rgba(0, 0, 0, 0.3);
      `}
    ${({ category }) =>
      category &&
      css`
        background-color: ${backgroundColors[category]?.dark || 'inherit'};
      `};
  }
`;

export default StyledEducationShape;
